/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {registerDevice} from '../api'

export const useMutationRegisterDevice = createReactQueryMutationHook('registerDevice', registerDevice)
